import { render, staticRenderFns } from "./ImportantDisclosureItem.vue?vue&type=template&id=08786261&"
import script from "./ImportantDisclosureItem.vue?vue&type=script&lang=js&"
export * from "./ImportantDisclosureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports